import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-add-carrier-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './add-carrier-dialog.html',
  styleUrl: './add-carrier-dialog.css'
})
export class AddCarrierDialog {
  @Input() adding: boolean = false;
  @Input() error: string | null = null;
  @Output() closed = new EventEmitter<void>();
  @Output() submitCarrier = new EventEmitter<{ apiKey: string }>();

  apiKey: string = '';

  onCancel(): void { this.closed.emit(); }

  onApiKeyInput(event: Event): void {
    const value = (event.target as HTMLInputElement)?.value ?? '';
    this.apiKey = value;
  }

  onSubmit(): void {
    this.submitCarrier.emit({ apiKey: (this.apiKey || '').trim() });
  }
}


